import CreateDGAConfigurationModal from './CreateDGAConfigurationModal';
import DGAReportsRetryModal from './DGAReportsRetryModal';
import DeleteDGAConfigurationModal from './DeleteDGAConfigurationModal';
import UpdateDGAConfigurationModal from './UpdateDGAConfigurationModal';
import DGAReportsChartModal from './reports/ChartModal';
import DGAReportsTableModal from './reports/TableModal';

const DGAModals = () => {
  return (
    <>
      <UpdateDGAConfigurationModal />
      <CreateDGAConfigurationModal />
      <DGAReportsChartModal />
      <DGAReportsRetryModal />
      <DGAReportsTableModal />
      <DeleteDGAConfigurationModal />
    </>
  );
};

export default DGAModals;
